(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7145],{

/***/ 61322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _ui_VideoBlock_VideoBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61621);
/* harmony import */ var _ui_MainBanner_MainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30979);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84838);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _ui_OurManagement_OurManagement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32879);
/* harmony import */ var _constants_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70245);
/* harmony import */ var _ui_BoardOfDirectors_BoardOfDirectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39092);
/* harmony import */ var _ui_MediaInquire_MediaInquire__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13212);
/* harmony import */ var _ui_Company_Company__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17783);
/* harmony import */ var _news_NewsSingle_NewsSingle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19673);
/* harmony import */ var _home__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1822);
/* harmony import */ var _news_NewsList_NewsList__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38703);
/* harmony import */ var _roaming__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4538);
/* harmony import */ var _TariffSliderBusiness_TariffSliderBusiness__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82563);
/* harmony import */ var _common_GoogleMapsClusterer_GoogleMapsClusterer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75482);
/* harmony import */ var _common_TariffsFilter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61024);
/* harmony import */ var _partnership_Form_Form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97608);
/* harmony import */ var _campaigns__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(56936);
/* harmony import */ var _tariffs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44952);
/* harmony import */ var _contact_us__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98778);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(972);
/* harmony import */ var _about_us__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18686);
/* harmony import */ var _business_join_us__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(32030);
/* harmony import */ var _choose_topic_ChooseTopic__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(70996);
/* harmony import */ var _support__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(64310);
/* harmony import */ var _TariffSliderBusiness_TariffSliderBusinessWithoutHeader__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(35819);
/* harmony import */ var _business_calls__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(86828);
/* harmony import */ var _find_your_number__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(87776);
/* harmony import */ var _business_fix_service_FixService__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(88426);
/* harmony import */ var _business_roaming__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(47433);
/* harmony import */ var _esim__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(31444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(57611);




































var WidgetWrapper = function WidgetWrapper(_ref) {
  var widgets = _ref.widgets;

  var renderWidgets = function renderWidgets(name, data) {
    var _data$cards;

    switch (name) {
      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SLIDER */ .Y.SLIDER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .BrandSlider */ .kx, {
          data: data,
          business: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.BEAUTIFUL_NUMBERS */ .Y.BEAUTIFUL_NUMBERS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .BookNumber */ .Jx, {
          tabs: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.RED_BANNER */ .Y.RED_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .Banner */ .jL, {
          item: data,
          isBusiness: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.APPLICATION_BANNER */ .Y.APPLICATION_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .AppBanner */ .yj, {
          className: "wrapper section",
          item: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.NEWS_SLIDER */ .Y.NEWS_SLIDER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .NewsList */ .pY, {
          className: "wrapper section",
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.IMAGE_BANNER */ .Y.IMAGE_BANNER:
      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.BLACK_BANNER */ .Y.BLACK_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .Banner */ .jL, {
          item: data,
          type: "red_banner",
          isBusiness: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.GRAY_BANNER */ .Y.GRAY_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .BusinessContactForm */ .Rm, {
          bannerData: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_SLIDER */ .Y.TARIFF_SLIDER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .Tariffs */ .Qw, {
          data: data,
          footerData: data === null || data === void 0 ? void 0 : data.tags,
          title: data === null || data === void 0 ? void 0 : data.title,
          buttonText: data === null || data === void 0 ? void 0 : data.button_text
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.GENERAL_SERVICE */ .Y.GENERAL_SERVICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .GeneralServices */ .kO, {
          services: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.IMPORTANT_STEP */ .Y.IMPORTANT_STEP:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .Steps */ .Rg, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.FOR_FOREIGN_GUEST */ .Y.FOR_FOREIGN_GUEST:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .BannerAzer */ .jS, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ACCORDION */ .Y.ACCORDION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .Questions */ .Gw, {
          questions: data,
          className: "wrapper",
          titleModify: "title--large"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.HEADER */ .Y.HEADER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_MainBanner_MainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          dark: true,
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ROAMING_COUNTRY_SEARCH */ .Y.ROAMING_COUNTRY_SEARCH:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .SearchTravel */ .Ym, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.HOTSPOT_MAP */ .Y.HOTSPOT_MAP:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_common_GoogleMapsClusterer_GoogleMapsClusterer__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.NEW_CAMPAIGN */ .Y.NEW_CAMPAIGN:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_campaigns__WEBPACK_IMPORTED_MODULE_18__/* .CampaignList */ .Ir, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_DETAILS */ .Y.TARIFF_DETAILS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_tariffs__WEBPACK_IMPORTED_MODULE_19__/* .SingleTariffsContent */ .Gn, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.FIND_OUR_OFFICE */ .Y.FIND_OUR_OFFICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_contact_us__WEBPACK_IMPORTED_MODULE_20__/* .OfficesList */ .T, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.HEADER_LINKS */ .Y.HEADER_LINKS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_tariffs__WEBPACK_IMPORTED_MODULE_19__/* .SingleTariffsTabs */ .YF, {
          tabs: data.links
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_CHOICE */ .Y.TARIFF_CHOICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_tariffs__WEBPACK_IMPORTED_MODULE_19__/* .FindBundle */ .Kp, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_FILTER */ .Y.TARIFF_FILTER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_common_TariffsFilter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ADVANTAGEOUS_PRICE */ .Y.ADVANTAGEOUS_PRICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .Advantageous */ .KU, {
          advantageousData: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.FIND_YOUR_NUMBER_ESIM */ .Y.FIND_YOUR_NUMBER_ESIM:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_esim__WEBPACK_IMPORTED_MODULE_31__/* .FindYourEsimFlow */ .HR, {
          detail: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ABOUT_ACTIVATION */ .Y.ABOUT_ACTIVATION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .ProductStatus */ .Pt, {
          statusData: data,
          className: "wrapper small-margin",
          isBlock: true,
          titleModify: "title--large",
          Icon: _icons_index__WEBPACK_IMPORTED_MODULE_4__/* .InfoQuestion */ .gz
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.OPERATION_LIST */ .Y.OPERATION_LIST:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServicesOperations */ .bi, {
          className: "wrapper small-margin",
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.GENERAL_INFORMATION */ .Y.GENERAL_INFORMATION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServiceReverse */ .er, {
          data: data,
          className: "wrapper section"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.VIDEO */ .Y.VIDEO:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServiceVideo */ .am, {
          className: "wrapper section",
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SIMPLE_APPLICATION_BANNER */ .Y.SIMPLE_APPLICATION_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .Banner */ .jL, {
          item: data,
          type: 'image_banner',
          href: '/1212',
          buttonHide: true,
          dangerTitle: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.WHITE_CARDS */ .Y.WHITE_CARDS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .CardBlock */ .qp, {
          className: "small-margin wrapper",
          data: data,
          gridValue: data === null || data === void 0 ? void 0 : (_data$cards = data.cards) === null || _data$cards === void 0 ? void 0 : _data$cards.length
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.VOLTE_BANNER */ .Y.VOLTE_BANNER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .StepsBannerWithTabsVolte */ .HE, {
          className: "section wrapper",
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.HORIZONTAL_TABLE */ .Y.HORIZONTAL_TABLE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_campaigns__WEBPACK_IMPORTED_MODULE_18__/* .CampaignTable */ .rc, {
          data: data,
          className: "wrapper small-margin",
          isHorisontal: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.VERTICAL_TABLE */ .Y.VERTICAL_TABLE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_campaigns__WEBPACK_IMPORTED_MODULE_18__/* .CampaignTable */ .rc, {
          data: data,
          Icon: _icons_index__WEBPACK_IMPORTED_MODULE_4__/* .Flash */ .Tx,
          className: "wrapper small-margin"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.VOLTE_DEVICE_SEARCH */ .Y.VOLTE_DEVICE_SEARCH:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .CheckCompatibility */ .HG, {
          data: data,
          className: "section wrapper"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.COMPANY_AWARD */ .Y.COMPANY_AWARD:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_about_us__WEBPACK_IMPORTED_MODULE_22__/* .Awards */ .pR, {
          data: data,
          className: "wrapper small-margin"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.COLOR_CARD */ .Y.COLOR_CARD:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_about_us__WEBPACK_IMPORTED_MODULE_22__/* .ColorCards */ .WX, {
          data: data,
          className: "wrapper section"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.KEY_MILESTONE */ .Y.KEY_MILESTONE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_about_us__WEBPACK_IMPORTED_MODULE_22__/* .Milestones */ .Vh, {
          className: "wrapper small-margin",
          data: data,
          isSmall: true
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.OPEN_POSITION */ .Y.OPEN_POSITION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_about_us__WEBPACK_IMPORTED_MODULE_22__/* .Vacancies */ .ZK, {
          data: data,
          className: "wrapper small-margin"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.CORPORATE_SOCIAL_RESPONSIBILITY */ .Y.CORPORATE_SOCIAL_RESPONSIBILITY:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_about_us__WEBPACK_IMPORTED_MODULE_22__/* .TitleBlock */ .Eq, {
          data: data,
          className: "section wrapper"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SMALL_CONTENT_BLOCK */ .Y.SMALL_CONTENT_BLOCK:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServiceContent */ .B$, {
          data: data,
          className: "wrapper section"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.GALLERY */ .Y.GALLERY:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServiceSlider */ .yi, {
          data: data,
          className: "wrapper section"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.OUR_MANAGEMENT */ .Y.OUR_MANAGEMENT:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_OurManagement_OurManagement__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.BOARD_OF_DIRECTORS */ .Y.BOARD_OF_DIRECTORS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_BoardOfDirectors_BoardOfDirectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.MEDIA_INQUIRE */ .Y.MEDIA_INQUIRE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_MediaInquire_MediaInquire__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SUSTAINABILITY */ .Y.SUSTAINABILITY:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .DocumentCard */ .z4, {
          data: data,
          className: 'wrapper section'
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ADDRESS_CARDS */ .Y.ADDRESS_CARDS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .AddressCards */ .d5, {
          data: data,
          className: 'wrapper section'
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.COMPANY */ .Y.COMPANY:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_Company_Company__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.PAYMENT_SYSTEMS */ .Y.PAYMENT_SYSTEMS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .PaymentCards */ .fP, {
          data: data,
          className: 'wrapper section'
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.PARTNERSHIP_REQUEST */ .Y.PARTNERSHIP_REQUEST:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_partnership_Form_Form__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.LATEST_NEWS */ .Y.LATEST_NEWS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_news_NewsList_NewsList__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          title: data === null || data === void 0 ? void 0 : data.title
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.CHOOSE_TOPIC_SECTION */ .Y.CHOOSE_TOPIC_SECTION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_choose_topic_ChooseTopic__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.POST_WIDGET */ .Y.POST_WIDGET:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_news_NewsSingle_NewsSingle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TOPIC_GROUPS */ .Y.TOPIC_GROUPS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_support__WEBPACK_IMPORTED_MODULE_25__/* .ChooseCategory */ .Ho, {
          data: data,
          className: 'wrapper section'
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.INFO_BLOCK */ .Y.INFO_BLOCK:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_business_calls__WEBPACK_IMPORTED_MODULE_27__/* .InfoBlock */ .U, {
          className: "wrapper section",
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.WHY_BAKCELL */ .Y.WHY_BAKCELL:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_business_join_us__WEBPACK_IMPORTED_MODULE_23__/* .WhyBlock */ .CJ, {
          data: data,
          className: "wrapper section"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.INFO_BOX */ .Y.INFO_BOX:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .BusinessSectionBannersWithIcon */ .CW, {
          data: data,
          className: 'wrapper section'
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.FIND_YOUR_NUMBER */ .Y.FIND_YOUR_NUMBER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_find_your_number__WEBPACK_IMPORTED_MODULE_28__/* .FindYourNumberFlow */ .d, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.BUSINNES_CARD */ .Y.BUSINNES_CARD:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_business_join_us__WEBPACK_IMPORTED_MODULE_23__/* .BusinessJoinUs */ .jt, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.VIDEO_BLOG */ .Y.VIDEO_BLOG:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_VideoBlock_VideoBlock__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.FIX_SERVICE */ .Y.FIX_SERVICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .FixServices */ .U7, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TECHNICAL_SOLUTION */ .Y.TECHNICAL_SOLUTION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_home__WEBPACK_IMPORTED_MODULE_11__/* .TechnicalSolutions */ .BP, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.PRICING_TABLE */ .Y.PRICING_TABLE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_business_fix_service_FixService__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_SLIDER_BUSINESS */ .Y.TARIFF_SLIDER_BUSINESS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_TariffSliderBusiness_TariffSliderBusiness__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.M2M_BUNDLES */ .Y.M2M_BUNDLES:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .Bundles */ .gl, {
          data: data,
          className: "wrapper card-margin"
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.BUSINESS_ADVANTAGEOUS_PRICE */ .Y.BUSINESS_ADVANTAGEOUS_PRICE:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_business_roaming__WEBPACK_IMPORTED_MODULE_30__/* .Advantageous */ .KU, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.INTERNET_ACTIVATION */ .Y.INTERNET_ACTIVATION:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .InternetActivation */ .YN, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ROAMING_ACTIVATION_BUSINESS */ .Y.ROAMING_ACTIVATION_BUSINESS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_roaming__WEBPACK_IMPORTED_MODULE_13__/* .RoamingActivation */ .Dw, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.ROAMING_COUNTRY_SEARCH_BUSINESS */ .Y.ROAMING_COUNTRY_SEARCH_BUSINESS:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .SearchTravel */ .Ym, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER */ .Y.TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_TariffSliderBusiness_TariffSliderBusinessWithoutHeader__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SERVICES */ .Y.SERVICES:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_services__WEBPACK_IMPORTED_MODULE_21__/* .ServicesGrid */ .jW, {
          data: data
        });

      case _constants_widgets__WEBPACK_IMPORTED_MODULE_6__/* .widgetOptions.SEARCH_RESULT_WIDGET */ .Y.SEARCH_RESULT_WIDGET:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_3__/* .SearchList */ .Dl, {
          data: data
        });

      default:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)("div", {
          className: "wrapper",
          children: [name, " not found"]
        });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.Fragment, {
    children: widgets === null || widgets === void 0 ? void 0 : widgets.map(function (item) {
      return renderWidgets(item.type, item);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WidgetWrapper);

/***/ }),

/***/ 5913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9605);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_business_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61322);
/* harmony import */ var _components_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);
/* eslint-disable @next/next/next-script-for-ga */






var __N_SSP = true;
function Home(_ref) {
  var _parsedData$metadata, _parsedData$metadata2, _parsedData$metadata3, _parsedData$metadata4, _parsedData$metadata5;

  var data = _ref.data;
  var parsedData = JSON.parse(data);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_common__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
      navbar: parsedData === null || parsedData === void 0 ? void 0 : parsedData.menu,
      footer: parsedData === null || parsedData === void 0 ? void 0 : parsedData.footer,
      metadata: parsedData === null || parsedData === void 0 ? void 0 : parsedData.metadata,
      breadcrumbs: parsedData === null || parsedData === void 0 ? void 0 : parsedData.breadcrumbs,
      appDownload: parsedData === null || parsedData === void 0 ? void 0 : parsedData.app_download_widget,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", {
          children: (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata = parsedData.metadata) === null || _parsedData$metadata === void 0 ? void 0 : _parsedData$metadata.title) || (parsedData === null || parsedData === void 0 ? void 0 : parsedData.name)
        }), (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata2 = parsedData.metadata) === null || _parsedData$metadata2 === void 0 ? void 0 : _parsedData$metadata2.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
          name: "description",
          content: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata3 = parsedData.metadata) === null || _parsedData$metadata3 === void 0 ? void 0 : _parsedData$metadata3.description
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
          name: "keywords",
          content: (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata4 = parsedData.metadata) === null || _parsedData$metadata4 === void 0 ? void 0 : _parsedData$metadata4.keywords) || (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata5 = parsedData.metadata) === null || _parsedData$metadata5 === void 0 ? void 0 : _parsedData$metadata5.title) || 'Bakcell'
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_business_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        widgets: parsedData === null || parsedData === void 0 ? void 0 : parsedData.widgets
      })]
    })
  });
}

/***/ }),

/***/ 61109:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business",
      function () {
        return __webpack_require__(5913);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5443,1255,7847,6913,8922,5403,2030,9774,2888,179], function() { return __webpack_exec__(61109); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);